<template>
  <div class="flex">
    <div
      class="search-full-container"
      :class="{ flex: showFullSearch }"
      v-show="showFullSearch"
    >
      <vx-auto-suggest
        ref="navbarSearch"
        :autoFocus="showFullSearch"
        :data="navbarSearchAndPinList"
        search_key="title"
        background-overlay
        class="w-full"
        inputClassses="vs-input-no-border vs-input-no-shdow-focus "
        placeholder="Explore Vuexy..."
        @input="hnd_search_query_update"
        @selected="selected"
        @closeSearchbar="showFullSearch = false"
      >
        <template v-slot:group="{ group_name }">
          <p class="font-semibold text-primary">{{ group_name }}</p>
        </template>
        <!-- Pages Suggestion -->
        <template v-slot:pages="{ suggestion }">
          <div class="flex items-end leading-none py-1">
            <feather-icon
              :icon="suggestion.icon"
              svgClasses="h-5 w-5"
              class="mr-4"
            />
            <span class="mt-1">{{ suggestion.title }}</span>
          </div>
        </template>
        <!-- No Items Slot -->
        <template v-slot:noResult="{ group_name }">
          <div class="flex items-center">
            <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="mr-4" />
            <span>No results found.</span>
          </div>
        </template>
      </vx-auto-suggest>

      <div class="relative right-0 h-full z-50">
        <feather-icon
          icon="XIcon"
          class="px-4 cursor-pointer h-full close-search-icon"
          @click="showFullSearch = false"
        />
      </div>
    </div>
    <div class="notification-area">
      <feather-icon
        icon="SearchIcon"
        @click="showFullSearch = true"
        class="cursor-pointer navbar-fuzzy-search mr-4"
      />
    </div>
  </div>
</template>

<script>
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
export default {
  components: {
    VxAutoSuggest,
  },
  data() {
    return {
      navbarSearchAndPinList: [{ name: "Customer List", route: "/customer" }],
      showFullSearch: false,
    };
  },
  methods: {
    selected(item) {
      item.pages ? this.$router.push(item.pages.url).catch(() => {}) : null;
      this.showFullSearch = false;
    },
    hnd_search_query_update(query) {
      this.$store.commit("TOGGLE_CONTENT_OVERLAY", query ? true : false);
    },
  },
};
</script>
<style lang="scss" scoped>
.search-full-container {
  background: rgb(234, 234, 0);
  .vx-auto-suggest .vs-con-input-label .vs-con-input {
    border-radius: 50%;
    width: 10rem;
    position: absolute;
    top: 0;
  }
}
.notification-area {
  background: rgba(104, 94, 204, 0.15);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  text-align: center;
  margin-right: 1rem;
  .feather-icon {
    vertical-align: middle;
    margin-top: 8px;
    margin-left: 6px;
  }
}
</style>
